export default __webpack_public_path__ + "static/media/slide1.874e00b6.png";